var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBallonErrorRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.078,
    height: 20.786,
    viewBox: "0 0 20.078 20.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3715",
    "data-name": "Grupo 3715",
    transform: "translate(-991.721 -274.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2690",
    "data-name": "Caminho 2690",
    d: "M21.078,14.719V3.272A1.276,1.276,0,0,0,19.807,2H3.272A1.276,1.276,0,0,0,2,3.272V21.078l5.088-5.088H19.807A1.276,1.276,0,0,0,21.078,14.719Z",
    transform: "translate(990.221 273)",
    fill: "none",
    stroke: "#f00909",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3719",
    "data-name": "Grupo 3719",
    transform: "translate(0.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2691",
    "data-name": "Caminho 2691",
    d: "M0,0H2V4.938H0Z",
    transform: "translate(1000.299 278)",
    fill: "#f00909"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2662",
    "data-name": "Ret\\xE2ngulo 2662",
    width: 2,
    height: 2,
    transform: "translate(1000.299 284)",
    fill: "#f00909"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallonErrorRed);
export default __webpack_public_path__ + "static/media/ballon_error_red.36b67431.svg";
export { ForwardRef as ReactComponent };